import { Controller } from "@hotwired/stimulus"

// Contrôleur pour la sélection de club avec recherche
export default class extends Controller {
  static targets = ["input", "hiddenField", "results", "selected"]
  static values = {
    clubs: Array,
    placeholder: { type: String, default: "Rechercher un club..." }
  }

  connect() {
    this.selectedClub = null
    // Écouteur pour fermer les résultats quand on clique en dehors
    this.boundCloseResults = this.closeResults.bind(this)
    document.addEventListener('click', this.boundCloseResults)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseResults)
  }

  showDefaultClubs() {
    // Ne rien faire si un club est déjà sélectionné
    if (this.selectedClub) return

    // Afficher les 3 premiers clubs par défaut
    const defaultClubs = this.clubsValue.slice(0, 3)
    this.displayClubs(defaultClubs, true)
  }

  search() {
    const query = this.inputTarget.value.trim().toLowerCase()

    if (query.length === 0) {
      this.showDefaultClubs()
      return
    }

    const filtered = this.clubsValue.filter(club =>
      club.nom.toLowerCase().includes(query)
    )

    this.displayClubs(filtered, false)
  }

  displayClubs(clubs, showDefault = false) {
    if (clubs.length === 0) {
      this.resultsTarget.innerHTML = `
        <div class="p-3 text-sm text-gray-500 text-center">
          Aucun club trouve
        </div>
      `
      this.resultsTarget.classList.remove("hidden")
      return
    }

    const header = showDefault && this.clubsValue.length > 3
      ? `<div class="px-3 py-2 bg-gray-50 text-xs text-gray-500 border-b">
           Clubs recents (${this.clubsValue.length} disponibles)
         </div>`
      : ''

    const clubsHtml = clubs.map(club => `
      <div class="p-3 hover:bg-purple-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors"
           data-action="click->club-selector#selectClub"
           data-club-id="${club.id}"
           data-club-nom="${club.nom}">
        <div class="font-medium text-gray-900">${club.nom}</div>
        ${club.ville ? `<div class="text-sm text-gray-500">${club.ville}</div>` : ''}
      </div>
    `).join('')

    this.resultsTarget.innerHTML = header + clubsHtml
    this.resultsTarget.classList.remove("hidden")
  }

  selectClub(event) {
    const el = event.currentTarget
    const clubId = el.dataset.clubId
    const clubNom = el.dataset.clubNom

    this.selectedClub = { id: clubId, nom: clubNom }
    this.hiddenFieldTarget.value = clubId

    // Afficher le club selectionne
    this.selectedTarget.innerHTML = `
      <div class="flex items-center justify-between p-3 bg-purple-50 border-2 border-purple-200 rounded-lg">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
            <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
            </svg>
          </div>
          <span class="font-medium text-gray-900">${clubNom}</span>
        </div>
        <button type="button"
                class="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
                data-action="click->club-selector#clearSelection">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
    `
    this.selectedTarget.classList.remove("hidden")

    // Cacher l'input et les resultats
    this.inputTarget.classList.add("hidden")
    this.resultsTarget.classList.add("hidden")
  }

  clearSelection() {
    this.selectedClub = null
    this.hiddenFieldTarget.value = ""
    this.selectedTarget.classList.add("hidden")
    this.selectedTarget.innerHTML = ""
    this.inputTarget.classList.remove("hidden")
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this.showDefaultClubs()
  }

  // Fermer les resultats si on clique en dehors
  closeResults(event) {
    if (!this.element.contains(event.target)) {
      this.resultsTarget.classList.add("hidden")
    }
  }
}
